var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var ACTIONS;
(function (ACTIONS) {
    ACTIONS[ACTIONS["ENQUEUE"] = 0] = "ENQUEUE";
    ACTIONS[ACTIONS["RESET_STATE"] = 1] = "RESET_STATE";
})(ACTIONS || (ACTIONS = {}));
var QUEUE_LENGTH = 10;
var initRegionQueue = [];
for (var i = 0; i < QUEUE_LENGTH; i += 1)
    initRegionQueue.push({ announcementIndex: -1, announcement: '' });
export var initialRegionState = {
    nextRegionIndex: 0,
    nextAnnouncementIndex: 0,
    queue: initRegionQueue,
};
var nextRegionIndex = function (currentRegionIndex) {
    return currentRegionIndex === QUEUE_LENGTH - 1 ? 0 : currentRegionIndex + 1;
};
export var regionReducer = function (state, action) {
    var currentRegionIndex = state.nextRegionIndex;
    var currentAnnouncementIndex = state.nextAnnouncementIndex;
    var clone = __spreadArray([], __read(state.queue), false);
    switch (action.type) {
        case ACTIONS.RESET_STATE:
            return initialRegionState;
        case ACTIONS.ENQUEUE:
            clone[currentRegionIndex] = __assign(__assign({}, action.payload), { announcementIndex: currentAnnouncementIndex });
            return {
                nextRegionIndex: nextRegionIndex(currentRegionIndex),
                nextAnnouncementIndex: currentAnnouncementIndex + 1,
                queue: clone,
            };
        default:
            return state;
    }
};
//# sourceMappingURL=reducerUtils.js.map